import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

export const ContentAiIcon = AutoFixHighIcon;
